<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.05</b> - призывы Дворф/Эльф/Фея и Куклы вуду ограничены 2~5,
      масштабируется с уровнем способности
    </p>
  </div>
</template>
